import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TicketTable = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get('https://register.tjdstore.in/api/get_ticket.php')
      .then(response => {
        setTickets(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching tickets:', error);
        setError('Failed to load ticket data');
        setLoading(false);
      });
  }, []);

  return (
    <div className="content mt-5">
      <div className="row">
        <div className="col-lg-12 col-md-12 mt-5 wel-sec">
          <h2 className="text-center mb-4">Ticket Details</h2>

          {loading && <p className="text-center">Loading tickets...</p>}
          {error && <p className="text-center text-danger">{error}</p>}

          {!loading && !error && (
            <div className="table-responsive">
              <table className="table table-striped table-bordered text-center">
                <thead className="table-dark">
                  <tr>
                    <th>Order ID</th>
                    <th>Ticket Category</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Amount</th>
                    <th>Quantity</th>
                    <th>Payment Method</th>
                    <th>Upgrade From</th>
                     <th>Upgrade To</th>                   
                    <th>Reference</th>
                  </tr>
                </thead>
                <tbody>
                  {tickets.length > 0 ? (
                    tickets.map(ticket => (
                      <tr key={ticket.id}>
                        <td>{ticket.order_id}</td>
                        <td>{ticket.ticket_cat}</td>
                        <td>{ticket.name}</td>
                        <td>{ticket.email}</td>
                        <td>{ticket.mobile}</td>
                        <td>₹{ticket.amount}</td>
                        <td>{ticket.quantity}</td>
                        <td>{ticket.payment_method}</td>
                        <td>{ticket.upgrade_from}</td>
                        <td>{ticket.upgrade_to}</td>    
                         <td>{ticket.reference || '-'}</td>                    
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">No tickets found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TicketTable;
